// prettier-ignore
const MODE = {
  ARDUPILOT: {
    COPTER: {
      STABILIZE:       { id: 0,  name: 'Stabilize',       desc: 'Self-levels the roll and pitch axis.' },
      ACRO:            { id: 1,  name: 'Acro',            desc: 'Holds attitude, no self-level.' },
      ALTHOLD:         { id: 2,  name: 'AltHold',         desc: 'Holds altitude and self-levels the roll & pitch.' },
      AUTO:            { id: 3,  name: 'Auto',            desc: 'Executes pre-defined mission.' },
      GUIDED:          { id: 4,  name: 'Guided',          desc: 'Navigates to single points commanded.' },
      LOITER:          { id: 5,  name: 'Loiter',          desc: 'Holds altitude and position, uses GPS for movements.' },
      RTL:             { id: 6,  name: 'RTL',             desc: 'Returns above takeoff location, may also include landing.' },
      CIRCLE:          { id: 7,  name: 'Circle',          desc: 'Automatically circles a point in front of the vehicle.' },
      LAND:            { id: 9,  name: 'Land',            desc: 'Reduces altitude to ground level, attempts to go straight down.' },
      DRIFT:           { id: 11, name: 'Drift',           desc: 'Like stabilize, but coordinates yaw with roll like a plane.' },
      SPORT:           { id: 13, name: 'Sport',           desc: 'Alt-hold, but holds pitch & roll when sticks centered.' },
      FLIP:            { id: 14, name: 'Flip',            desc: 'Rises and completes an automated flip.' },
      AUTOTUNE:        { id: 15, name: 'AutoTune',        desc: 'Automated pitch and bank procedure to improve control loops.' },
      POSHOLD:         { id: 16, name: 'PosHold',         desc: 'Like loiter, but manual roll and pitch when sticks not centered.' },
      BRAKE:           { id: 17, name: 'Brake',           desc: 'Brings copter to an immediate stop.' },
      THROW:           { id: 18, name: 'Throw',           desc: 'Holds position after a throwing takeoff. Multirotors only.' },
      AVOID_ADSB:      { id: 19, name: 'Avoid ADSB',      desc: 'Auto-avoids manned aircraft using ADS-B data.' },
      GUIDED_NOGPS:    { id: 20, name: 'Guided NoGPS',    desc: 'Not allow a vehicle to hold position without a GPS.' },
      SMART_RTL:       { id: 21, name: 'Smart RTL',       desc: 'RTL, but traces path to get home.' },
      FLOWHOLD:        { id: 22, name: 'FlowHold',        desc: 'Position control using Optical Flow.' },
      FOLLOW:          { id: 23, name: 'Follow',          desc: 'Follows another vehicle.' },
      ZIGZAG:          { id: 24, name: 'ZigZag',          desc: 'Useful for crop spraying.' },
      SYSTEM_ID:       { id: 25, name: 'System ID',       desc: 'Special diagnostic/modeling mode.' },
      HELI_AUTOROTATE: { id: 26, name: 'Heli Autorotate', desc: 'Emergency mode for helicopters only, SITL use only.' },
      AUTO_RTL:        { id: 27, name: 'Auto RTL',        desc: 'Returns the vehicle straight to home automatically.' },
    },
    PLANE: {
      MANUAL:          { id: 0,  name: 'Manual',          desc: 'Manual control surface movement, passthrough.' },
      CIRCLE:          { id: 1,  name: 'Circle',          desc: 'Gently turns aircraft.' },
      STABILIZE:       { id: 2,  name: 'Stabilize',       desc: 'Wing-leveling on stick release.' },
      TRANING:         { id: 3,  name: 'Traning',         desc: 'Manual control up to roll and pitch limits.' },
      ACRO:            { id: 4,  name: 'Acro',            desc: 'rate controlled mode with no attitude limits.' },
      FBWA:            { id: 5,  name: 'FBWA',            desc: 'Roll and pitch follow stick input, up to set limits.' },
      FBWB:            { id: 6,  name: 'FBWB',            desc: 'like FBWA, but with automatic height and speed control.' },
      CRUISE:          { id: 7,  name: 'Cruise',          desc: 'like FBWB, but with ground course tracking.' },
      AUTOTUNE:        { id: 8,  name: 'AutoTune',        desc: 'like FBWA, but learns attitude tuning while flying.' },
      AUTO:            { id: 10, name: 'Auto',            desc: 'Follows Mission.' },
      RTL:             { id: 11, name: 'RTL',             desc: 'Returns to and circles home or rally point.' },
      LOITER:          { id: 12, name: 'Loiter',          desc: 'Circles point where mode switched.' },
      TAKEOFF:         { id: 13, name: 'Takeoff',         desc: 'Automatic takeoff to specific altitude, and loiter at distance from takeoff until mode is changed.' },
      AVOID_ADSB:      { id: 14, name: 'Avoid ADSB',      desc: 'Auto-avoids manned aircraft using ADS-B data.' },
      GUIDED:          { id: 15, name: 'Guided',          desc: 'Circles user defined point.' },
      QSTABILIZE:      { id: 17, name: 'QStabilize',      desc: 'allows you to fly your vehicle manually, but self-levels the roll and pitch axis.' },
      QHOVER:          { id: 18, name: 'QHover',          desc: 'Holds altitude while allowing normal attitude control.' },
      QLOITER:         { id: 19, name: 'QLoiter',         desc: 'Holds position, heading, and altitude when sticks are released.' },
      QLAND:           { id: 20, name: 'QLand',           desc: 'Descends vertically in two stages to land at the current position.' },
      QRTL:            { id: 21, name: 'QRTL',            desc: 'Returns the QuadPlane to home, hovers, then lands.' },
      QAUTOTUNE:       { id: 22, name: 'QAutoTune',       desc: 'Auto-Tunes PIDs like Copter but isn\'t recommended for Tailsitter pitch or yaw.' },
      QACRO:           { id: 23, name: 'QAcro',           desc: 'Provides rate-based control for acrobatic QuadPlane flight.' },
      THERMAL:         { id: 24, name: 'Thermal',         desc: 'Mode entered to search for thermal lift by SOARING feature or manually if lift is encountered.' },
      LOITER_TO_QLAND: { id: 25, name: 'Loiter to QLand', desc: 'Descends in fixed-wing loiter, then switches to QLAND at a set altitude.' },
    },
    ROVER: {
      MANUAL:          { id: 0,  name: 'Manual'},
      ACRO:            { id: 1,  name: 'Acro'},
      STEERING:        { id: 3,  name: 'Steering'},
      HOLD:            { id: 4,  name: 'Hold'},
      LOITER:          { id: 5,  name: 'Loiter'},
      FOLLOW:          { id: 6,  name: 'Follow'},
      SIMPLE:          { id: 7,  name: 'Simple'},
      AUTO:            { id: 10, name: 'Auto'},
      RTL:             { id: 11, name: 'RTL'},
      SMART_RTL:       { id: 12, name: 'Smart RTL'},
      GUIDED:          { id: 15, name: 'Guided'},
    },
  },
  PX4: {
    ROVER: {
      MANUAL:         { id: 65536,     name: 'Manual' },
      STABILIZED:     { id: 458752,    name: 'Stabilized' },
      ACRO:           { id: 327680,    name: 'Acro' },
      ALTITUDE:       { id: 131072,    name: 'Altitude' },
      POSITION:       { id: 196608,    name: 'Position' },
      HOLD:           { id: 50593792,  name: 'Hold' },
      MISSION:        { id: 67371008,  name: 'Mission' },
      RETURN:         { id: 84148224,  name: 'Return' },
      FOLLOW_ME:      { id: 134479872, name: 'Follow Me' },
      PRECISION_LAND: { id: 151257088, name: 'Precision Land' },
    },
    COPTER: {
      MANUAL:         { id: 65536,     name: 'Manual' },
      STABILIZED:     { id: 458752,    name: 'Stabilized' },
      ACRO:           { id: 327680,    name: 'Acro' },
      ALTITUDE:       { id: 131072,    name: 'Altitude' },
      POSITION:       { id: 196608,    name: 'Position' },
      TAKEOFF:        { id: 33816576,  name: 'Takeoff' },
      HOLD:           { id: 50593792,  name: 'Hold' },
      MISSION:        { id: 67371008,  name: 'Mission' },
      RETURN:         { id: 84148224,  name: 'Return' },
      LAND:           { id: 100925440, name: 'Land' },
      FOLLOW_ME:      { id: 134479872, name: 'Follow Me' },
      PRECISION_LAND: { id: 151257088, name: 'Precision Land' },
    },
  },
  DJI: {
    STANDBY:                       { id: 0,  name: 'Standby'},
    TAKEOFF_PREPARATION:           { id: 1,  name: 'Takeoff Preparation'},
    TAKEOFF_PREPARATION_COMPLETED: { id: 2,  name: 'Takeoff Preparation Completed'},
    MANUAL_FLIGHT:                 { id: 3,  name: 'Manual Flight'},
    AUTOMATIC_TAKEOFF:             { id: 4,  name: 'Automatic Takeoff'},
    WAYLINE_FLIGHT:                { id: 5,  name: 'Wayline Flight'},
    PANORAMIC_PHOTOGRAPHY:         { id: 6,  name: 'Panoramic Photography'},
    INTELLIGENT_TRACKING:          { id: 7,  name: 'Intelligent Tracking'},
    ADSB_AVOIDANCE:                { id: 8,  name: 'ADS-B Avoidance'},
    AUTO_RETURNING_TO_HOME:        { id: 9,  name: 'Auto Returning to Home'},
    AUTOMATIC_LANDING:             { id: 10, name: 'Automatic Landing'},
    FORCED_LANDING:                { id: 11, name: 'Forced Landing'},
    THREE_BLADE_LANDING:           { id: 12, name: 'Three-blade Landing'},
    UPGRADING:                     { id: 13, name: 'Upgrading'},
    NOT_CONNECTED:                 { id: 14, name: 'Not Connected'},
    APAS:                          { id: 15, name: 'APAS' },
    VIRTUAL_STICK_STATE:           { id: 16, name: 'Virtual Stick State'},
    LIVE_FLIGHT_CONTROLS:          { id: 17, name: 'Live Flight Controls'},
    AIRBORNE_RTK_FIXING_MODE:      { id: 18, name: 'Airborne RTK Fixing Mode'},
    DOCK_ADDRESS_SELECTION_MODE:   { id: 19, name: 'Dock Address Selection Mode'},
  }
};

const LANDED_STATE = {
  1: 'On Ground',
  2: 'In Air',
  3: 'Takeoff',
  4: 'Landing',
};

const FC_STATUS = {
  0: 'Uninitialized',
  1: 'Booting Up',
  2: 'Calibrating',
  3: 'On Stanby',
  4: 'Active',
  5: 'Critical',
  6: 'Emergency',
  7: 'Power Off',
  8: 'Termination',
};

// prettier-ignore
// https://mavlink.io/en/messages/common.html#GPS_FIX_TYPE
const GPS_FIX_TYPE = {
  0: { name: 'No GPS',    full: 'No GPS connected' },
  1: { name: 'Searching', full: 'No position information, GPS is connected' },
  2: { name: '2D Fix',    full: '2D position' },
  3: { name: '3D Fix',    full: '3D position' },
  4: { name: 'DGPS',      full: 'DGPS/SBAS aided 3D position' },
  5: { name: 'RTK',       full: 'RTK float, 3D position' },
  6: { name: 'RTK Fixed', full: 'RTK Fixed, 3D position' },
  7: { name: 'Static',    full: 'Static fixed, typically used for base stations' },
  8: { name: 'PPP',       full: 'PPP, 3D position' },
};

// prettier-ignore
const ROBOT_STATUS = {
  BOOTING:   { code: 10, name: 'Booting' },
  REBOOTING: { code: 15, name: 'Rebooting' },
  STARTING:  { code: 20, name: 'Starting' },
  UPDATING:  { code: 25, name: 'Updating' },
  ONLINE:    { code: 30, name: 'Online' },
  ISSUE:     { code: 90, name: 'Issue' },
};

export { MODE, LANDED_STATE, FC_STATUS, GPS_FIX_TYPE, ROBOT_STATUS };
